import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { performApiRequest, getApiDataRequest, invalidateApiDataRequest } from '../redux/apiData';
import ArticleCard from './ArticleCard';
import Pagination from './Pagination';
import { fromBreakpoint } from '../styles/breakpoints';
import { CardCollectionContainer } from './shared/designElements/CardElements';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _ownProps$match$param = ownProps.match.params,
    projectSlug = _ownProps$match$param.projectSlug,
    env = _ownProps$match$param.env;
  return {
    latestRequest: getApiDataRequest(state.apiData, 'getArticlePage', {
      projectSlug: String(projectSlug),
      env: String(env),
      blockId: ownProps.id,
      pageNumber: ownProps.pagination.pageNumber
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onPress: function onPress(projectSlug, env, blockId, pageNumber, currentPage) {
      dispatch(invalidateApiDataRequest('getArticlePage', {
        projectSlug: String(projectSlug),
        env: String(env),
        blockId: blockId,
        pageNumber: currentPage
      }));
      dispatch(performApiRequest('getArticlePage', {
        projectSlug: projectSlug,
        env: env,
        blockId: blockId,
        pageNumber: pageNumber
      }));
    }
  };
};
var ArticleCollection = /*#__PURE__*/function (_PureComponent) {
  function ArticleCollection() {
    var _this;
    _classCallCheck(this, ArticleCollection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ArticleCollection, [].concat(args));
    _defineProperty(_this, "containerRef", null);
    _defineProperty(_this, "state", {
      isLoading: false
    });
    _defineProperty(_this, "handleClick", function (pageNumber) {
      _this.setState({
        isLoading: true
      });
      var _this$props = _this.props,
        match = _this$props.match,
        id = _this$props.id,
        pagination = _this$props.pagination,
        onPress = _this$props.onPress;
      onPress(String(match.params.projectSlug), String(match.params.env), id, pageNumber, pagination.pageNumber);
    });
    return _this;
  }
  _inherits(ArticleCollection, _PureComponent);
  return _createClass(ArticleCollection, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      var latestRequest = this.props.latestRequest;
      if (latestRequest && latestRequest.networkStatus === 'success' && this.state.isLoading) {
        this.setState({
          isLoading: false
        });
        setTimeout(function () {
          if (_this2.containerRef) {
            _this2.containerRef.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        pagination = _this$props2.pagination,
        id = _this$props2.id,
        articles = _this$props2.articles,
        renderWidth = _this$props2.renderWidth;
      var totalPages = Math.ceil(pagination.totalItemCount / pagination.itemNumberPerPage);
      var currentPage = pagination.pageNumber - 1;
      return articles ? __jsx(ArticleBlock, {
        id: "article-block-".concat(id),
        ref: function ref(el) {
          _this3.containerRef = el;
        },
        "data-e2e-block-articlecollection": true,
        "data-id": "components_ArticleCollection_ArticleBlock"
      }, __jsx(ArticleContainer, {
        "data-id": "components_ArticleCollection_ArticleContainer"
      }, (articles[pagination.pageNumber] || []).map(function (article, index) {
        return __jsx(ArticleCard, {
          key: index,
          id: index,
          isBig: index === 0 || index % 11 === 0,
          type: article.type,
          leader: article.leader,
          image: article.image,
          title: article.title,
          theme: article.theme,
          label: article.label,
          author: article.author,
          eventDate: article.eventDate,
          slug: article.slug,
          renderWidth: renderWidth,
          "data-id": "components_ArticleCollection_ArticleCard"
        });
      })), totalPages > 1 && __jsx(PaginationWrapper, {
        "data-id": "components_ArticleCollection_PaginationWrapper"
      }, __jsx(Pagination, {
        blockId: id,
        totalPages: totalPages,
        currentPage: currentPage,
        isLoading: this.state.isLoading,
        visiblePages: 2,
        goToPageValue: this.handleClick,
        "data-id": "components_ArticleCollection_Pagination"
      }))) : null;
    }
  }]);
}(PureComponent);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(ArticleCollection));
var ArticleBlock = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 40rem;\n  margin-top: -40rem;\n  position: relative;\n  padding-top: 40rem;\n"])));
var ArticleContainer = styled(CardCollectionContainer)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  > * {\n    width: 100%;\n    ", ";\n\n    ", ";\n  }\n"])), fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: calc( ((1/2) * 100%) - 20rem );\n\n      &:nth-of-type(2n) {\n        margin-right: 20rem;\n      }\n\n      &:first-child {\n        width: 100%;\n      }\n    "]))), fromBreakpoint.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      width: calc( ((1/3) * 100%) - 13.333rem );\n\n      &:nth-of-type(3n) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 1) {\n        margin-right: 20rem;\n      }\n\n      &:nth-of-type(3n + 2) {\n        margin: 0rem;\n      }\n\n      &:first-child {\n        margin-right: 20rem;\n        width: calc( ((2/3) * 100%) - 7rem );\n      }\n    "]))));
var PaginationWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"])));